import { IExpertItem } from 'pages/profile/interface';

export interface ICreateArticleForm {
  title: string;
  author: string;
  url: string;
  highlight: string;
  bannerImgUrl: string;
  lead: string;
  body: string;
  assignedGroups: string[];
  highlightMedia: string;
  products: string[];
  experts: string[];
  contents: string[];
  groups: string[];
  categories: string[];
}

export interface IArticle {
  _id: string;
  isActive: boolean;
  entId: string;
  title: string;
  author: IExpertItem;
  url: string;
  highlight: string;
  bannerImgUrl: string;
  lead: string;
  body: string;
  assignedGroups: IArticleGroupItem[];
  assignedGroupList: IArticleGroupItem[];
  highlightMedia: IHighlightMedia;
  products: IArticleSessionItem[];
  experts: IExpertItem[];
  contents: IArticleSessionItem[];
  groups: IArticleGroupItem[];
  createdAt: string;
  categories: { id: string; name: string; }[];
}

export enum DifficultyLevels {
  beginner = 'Beginner',
  intermediate = 'Intermediate',
  hard = 'Hard',
}

export enum ModalStates {
  remove = 'REMOVE',
  publish = 'PUBLISH',
  close = 'CLOSE',
}

export interface IHighlightMedia {
  _id: string;
  title: string;
  contentUrl: string;
  fileType: string;
  fileCategory: string;
  thumbnail: string;
  fileSize: number;
}

export interface IArticleSessionItem {
  _id: string;
  title: string;
  description: string;
  language?: string;
  sessionType: string;
  audienceType?: string;
  isActive: boolean;
  expert: IExpertItem;
  numberOfSessions?: number;
  numberOfParticipants?: number;
  isObserverAllowed?: boolean;
  numberOfObservers?: number;
  bookedSessions?: number;
  availableSessions?: number;
  bookedObservers?: number;
  availableParticipants?: number;
  availableObservers?: number;
  fee?: string;
  currency?: string;
  discount?: string;
  observerFee?: string;
  observerCurrency?: string;
  observerDiscount?: string;
}

export interface IArticleGroupItem {
  _id: string;
  groupType: string;
  title: string;
  subTitle?: string;
  description: string;
  bannerImgUrl?: string;
  followersCount?: number;
  users?: string[];
}

export interface ArticleState {
  entId: string;
  loading: boolean;
  isActive: boolean;
  articleFormData: ICreateArticleForm;
  previewArticle: IArticle;
  articles: IArticle[];
  total: number;
  experts: IExpertItem[];
}

export interface ICreateArticleStateAction {
  payload: ICreateArticleForm;
  type: string;
}

export interface IArticleRequest {
  articles: IArticle[];
  total: number;
}

export interface IViewArticleAction {
  payload: any;
  type: string;
}

export interface IPreviewArticleAction {
  payload: string;
  type: string;
}
export interface IDeleteArticleAction {
  payload: string;
  type: string;
}

export interface IPublishArticle {
  id:string, isActive:boolean
}

export interface IPublishArticleAction {
  payload:IPublishArticle,
  type:string
}

export interface IUpdateArticle {
  id: string;
  data: ICreateArticleForm;
}

export interface IUpdateArticleAction {
  payload: IUpdateArticle;
  type: string;
}

export interface IOpenModal {
  id: string;
  state: ModalStates;
}

export interface IArticleFilterPayload {
  entId: string;
  keyword: string;
  page: number;
  limit: number;
  sortBy: string;
}
export interface IArticleFilterByExpertsPayload {
  keyword: string;
  page: number;
  limit: number;
  sortBy: string;
  expertIds?: string[] | null;
}
export interface IArticleFilterAction {
  payload: IArticleFilterPayload;
  type: string;
}

export interface IArticleByExpertsFilterAction {
  payload: IArticleFilterByExpertsPayload;
  type: string;
}
